export const POPULAR_CATEGORIES_DATA = {
  NAME: "t3",
  URL: "t4",
};
